export default {
  title_one: '🥳 {{offer}} käytössä',
  title_other: '🥳 {{count}} tarjousta käytössä',
};
